import React, { PropsWithChildren, useContext } from 'react';

import { LogDataFormGroupProps, UnitNode } from '../../components';

export interface AccordionContextValue {
  setLogData?: (unitNode: UnitNode) => LogDataFormGroupProps;
}

const AccordionContext = React.createContext<AccordionContextValue>({});
export const useAccordionContext = () => useContext(AccordionContext);

export function AccordionContextProvider({
  children,
  value = {},
}: PropsWithChildren<{ value?: AccordionContextValue }>) {
  return (
    <AccordionContext.Provider value={value}>{ children }</AccordionContext.Provider>
  );
}
